import WithRender from "../../templates/imageEditor/layerItem.html";
import { mapGetters } from "vuex";
import * as R from "ramda";
import Rectangle from "./Rectangle";
import ItemHelperline from "./ItemHelperline";

export default WithRender({
  components: {
    appRectangle: Rectangle,
    appItemHelperline: ItemHelperline
  },
  props: ["item", "index", "updateItem", "defaultItemProps"],
  computed: {
    ...mapGetters([]),
    completeItem: function () {
      return R.merge(this.defaultItemProps, this.item);
    }
  },
  methods: {}
});
